// @flow
import { ImagesActionTypes } from './constants';

const INIT_STATE = {
    loading: false,
    error: false,
    images: []
};

type ImagesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { images?: [] | null, loading?: boolean, +value ?: boolean };

const Images = (state: State = INIT_STATE, action: ImagesAction): any => {
    // console.log(action);
    switch (action.type) {
        case ImagesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ImagesActionTypes.GET_IMAGES: {
                    return {
                        ...state,
                        images: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case ImagesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ImagesActionTypes.GET_IMAGES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        images: [],
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }

        case ImagesActionTypes.GET_IMAGES:
            return { ...state, error: false, loading: true };
        case ImagesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
            }
        default:
            return { ...state };
    }
};

export default Images;
